import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '../../../../../components/CiscoUi';
import { HelpButtonContainer } from '../../../../../components/HelpButton/container.tsx';
import { PageHeading } from '../../../../../components/PageHeading';
import { MAIL_SERVER_HELP_LINKS } from '../../../../../constants/user-guide';
import { MailServerAddFormContainer } from './components/MailServerAddForm/container';
import { MailServerDeleteModal } from './components/MailServerDeleteModal';
import { MailServersTable } from './components/MailServerTable';
import { MailServerProps } from './container';

export function MailServers({
  isError,
  isLoading,
  mailServers,
  dnsAssets,
  vmTargets,
  mailServerToDelete,
  setMailServerToDelete,
}: MailServerProps): ReactElement | null {
  const { t } = useTranslation();

  return (
    <section className="half-padding-left">
      <PageHeading pageTitle={t('traffic.mailServer.name')} />
      {!mailServers?.length && !isLoading && vmTargets?.length ? (
        <MailServerAddFormContainer
          dnsAssets={dnsAssets}
          vmTargets={vmTargets}
        />
      ) : null}
      {!mailServers?.length && !isLoading ? (
        <Alert colour="info">{t('traffic.mailServer.empty')}</Alert>
      ) : (
        <MailServersTable
          mailServers={mailServers || []}
          isError={isError}
          isLoading={isLoading}
          setMailServerToDelete={setMailServerToDelete}
        />
      )}
      {mailServers?.length
        ? null
        : !vmTargets?.length && (
            <Alert colour="info">
              {t('traffic.mailServer.noConfiguredMailserver')}
            </Alert>
          )}
      {mailServerToDelete && (
        <MailServerDeleteModal
          setMailServerToDelete={setMailServerToDelete}
          mailServer={mailServerToDelete}
        />
      )}
      <HelpButtonContainer links={MAIL_SERVER_HELP_LINKS} />
    </section>
  );
}
